// extracted by mini-css-extract-plugin
module.exports = {"actions":"style_actions__3A7Ig","title":"style_title__3VSMy","parentGroupName":"style_parentGroupName__2d1I4"};